module.exports = __webpack_public_path__ + "img/empty@2x.554361fc.png";